import { getErrorsList } from '@epi-helpers/ErrorDataHelper';

import { ApiConstants } from '../../constants/actions';
import createReducer from '../../helpers/CreateReducer';

interface Error {
  name: string;
  code: string;
  message: string;
}

interface ErrorState {
  errors: Error[];
  message: string;
  actionName: string;
  isError: boolean;
  noPersistance: boolean;
}

interface ApiErrorPayload {
  content?: any;
  message: string;
}

interface ApiErrorAction {
  actionName: string;
  payload: ApiErrorPayload;
}

export const getInitialState = (): ErrorState => ({
  errors: [],
  message: '',
  actionName: '',
  isError: false,
  noPersistance: true
});

export default createReducer(getInitialState, {
  [ApiConstants.SAVE_API_ERROR]: (
    state: ErrorState,
    { actionName, payload: { content, message } }: ApiErrorAction
  ): ErrorState => {
    const errors = content && getErrorsList(content);

    return {
      isError: true,
      errors,
      message,
      actionName,
      noPersistance: true
    };
  },

  [ApiConstants.CLEAR_API_ERROR]: (): ErrorState => ({
    isError: false,
    errors: [],
    message: '',
    actionName: '',
    noPersistance: true
  })
});
